import * as Config from '../../../config';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import IconNext from './svg/IconNext';

function NextButton({ onClick, disable }) {
  const stateAutomix = useSelector(state => state.stateAutomix);
  return (
    <div className={`align`} onClick={!disable ? onClick(stateAutomix === 'mixing') : null} >
      <IconNext size={24} color={!disable ? Config.TYPE_SECONDARY : Config.TYPE_PLACEHOLDER} className={`cf-icon-fill-v2 ${disable && 'disable'}`} />
    </div>
  )
}

NextButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default NextButton;
